import axios from 'axios'
// import { getToken } from "@/api/request.js"
axios.defaults.timeout = 5000;

const _HEAD = 'https://www.cdsszwhg.com/LsApi-master'

export function api(type, url, params) {
  if (localStorage.getItem('token')) {
    if (Math.round(new Date() / 1000) - JSON.parse(localStorage.getItem('token'))[1] > 7000) {
      return getToken(type, url, params)
    } else {
      axios.defaults.headers.common['token'] = JSON.parse(localStorage.getItem('token'))[0]
      if (type == 'get') {
        return get(url, params)
      }
    }
  } else {
    return getToken(type, url, params)
  }
}

let get = (url, params) => {
  return axios({
    method: 'get',
    url: _HEAD + url,
    params: params,
    // headers: {
    //   token: "1c075e3c9f134fbeb4ea672555f31453"
    // }
  })
}
//token
const getToken = function (type, url, params) {
  return axios.get(_HEAD + '/v1/auth/getToken', {
    params: {
      appcode: '5101',
      secret: "C12WVzJzBLX1YVgekU995FjtVzJwOo"
    }
  }).then(res => {
    if (res.data.code == 1200) {
      axios.defaults.headers.common['token'] = res.data.data.access_token
      let usertoken = res.data.data.access_token;
      let timestamp = Math.round(new Date() / 1000);
      let tokenArr = [usertoken, timestamp];
      localStorage.setItem("token", JSON.stringify(tokenArr))
      if (type == 'get') {
        return get(url, params)
      }
    }
  })
}

// 请求拦截器
// axios.interceptors.request.use(
//   config => {
//     if (localStorage.getItem('token')) {
//       // config.headers.Authorization = localStorage.token;
//       config.headers.token = JSON.parse(localStorage.getItem("token"))[0]
//     }
//     return config
//   },
//   error => Promise.error(error)
// )

//响应拦截
// axios.interceptors.response.use(
//   response=>{
//     console.log(response);
//     // if(response.data.code*1 ===1201){

//     // }
//   }
// )